

export class ApplicationModuleOutputWithoutStatus implements IApplicationModuleOutputWithoutStatus {
    /** The auto-generated id of the application module master */
    application_module_id!: number;
    /** The application module name with 255 character limit */
    application_module_name!: string;
    /** The application module image with 2048 character limit */
    application_module_image!: string;

    constructor(data?: IApplicationModuleOutputWithoutStatus) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.application_module_id = _data["application_module_id"];
            this.application_module_name = _data["application_module_name"];
            this.application_module_image = _data["application_module_image"];
        }
    }

    static fromJS(data: any): ApplicationModuleOutputWithoutStatus {
        data = typeof data === 'object' ? data : {};
        let result = new ApplicationModuleOutputWithoutStatus();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["application_module_id"] = this.application_module_id;
        data["application_module_name"] = this.application_module_name;
        data["application_module_image"] = this.application_module_image;
        return data; 
    }
}

export interface IApplicationModuleOutputWithoutStatus {
    /** The auto-generated id of the application module master */
    application_module_id: number;
    /** The application module name with 255 character limit */
    application_module_name: string;
    /** The application module image with 2048 character limit */
    application_module_image: string;
}

